"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BronsonModal = void 0;
const React = require("react");
const BronsonModal = (props) => {
    const [isHidden, setHidden] = React.useState(props.isHidden);
    React.useEffect(() => {
        setHidden(props.isHidden);
    }, [props.isHidden]);
    const closeModal = () => {
        setHidden(true);
        if (props.onClose)
            props.onClose(true);
    };
    const renderFooterCloseButton = () => {
        if (props.footerCloseButton !== false) {
            return (React.createElement("div", { className: 'c-modal__actions__item' },
                React.createElement("button", { className: 'c-btn c-btn--secondary', "aria-label": 'Close this dialog window.', onClick: closeModal, id: 'dh-bronson-model-default-close' },
                    React.createElement("span", { className: 'c-btn__text' }, props.footerCloseButtonText
                        ? props.footerCloseButtonText
                        : 'Cerrar'))));
        }
    };
    const renderFooterElements = () => {
        if (props.footerElements && props.footerElements.length) {
            return props.footerElements.map((elem, index) => {
                return (React.createElement("div", { key: index, className: 'c-modal__actions__item' }, elem));
            });
        }
    };
    return (React.createElement("div", { className: `c-modal ${props.largeModal ? 'c-modal--large' : ''}
            ${props.customClassModifier ? props.customClassModifier : ''}`, "aria-hidden": isHidden, id: 'dh-bronson-modal', "data-component": 'bronson-modal' },
        React.createElement("div", { className: 'c-modal__overlay', tabIndex: -1 }),
        React.createElement("div", { className: 'c-modal__wrapper', role: 'dialog', "aria-labelledby": 'dh-bronson-modal-wrapper' },
            React.createElement("header", { className: 'c-modal__header' },
                React.createElement("div", { className: 'c-modal__title__wrapper' },
                    props.beforeTitle ? props.beforeTitle : '',
                    React.createElement("h1", { className: 'c-modal__title', id: 'dh-bronson-modal-title' }, props.title)),
                props.hideCloseModal ? (React.createElement(React.Fragment, null)) : (React.createElement("button", { id: 'header-close-btn', className: 'c-modal__close-btn', type: 'button', "aria-label": 'Cerrar esta ventana', onClick: closeModal }))),
            React.createElement("div", { id: 'dh-bronson-modal-content', className: 'c-modal__content', role: 'document' }, React.createElement("div", null, props.content)),
            React.createElement("div", { className: 'c-modal__footer' },
                React.createElement("div", { className: 'c-modal__actions' },
                    renderFooterCloseButton(),
                    renderFooterElements()),
                props.footer ? props.footer : ''))));
};
exports.BronsonModal = BronsonModal;
